export default __webpack_public_path__ + "src/images/packages/ngama-tented-lodge/5e93f41eb4be9dd5c99a93d406b795bf-1.jpg";